import React from 'react';
import useGlobalHook from 'use-global-hook';
import * as actions from '../actions';

const initialState = {
    status: 'INITIAL',
    home: { home_status: 'PENDING' },
    contact: { contact_status: 'PENDING' },
    footer: { footer_status: 'PENDING' },
    header: { header_status: 'PENDING' },
    cornbids: { cornbids_status: 'PENDING' },
    termscondition: { termscondition_status: 'PENDING' },
};

const useGlobal = useGlobalHook(React, initialState, actions);

export default useGlobal;
